import trMessages from "./tr.json";
import enMessages from "./en.json";
import arMessages from "./ar.json";
import { Messages } from "./types"; // Tanımlanan türleri içe aktarıyoruz

// Mesajları JSON dosyalarından okuyoruz ve TypeScript türlerini kullanıyoruz
const messages: Record<string, Messages> = {
  tr: trMessages,
  en: enMessages,
  ar: arMessages,
};

export default messages;
